import {HTMLReactParserOptions, Element as ParserElement} from 'html-react-parser';
import {useTranslation} from 'react-i18next';

import {ClientDynamicContent, NodeElement} from 'components';
import {
    DynamicComponentNames,
    AppointmentSubmittedUnits as Units,
    APPOINTMENT_SUBMITTED_DEFAULT_TEMPLATE
} from 'constants/client';
import {useClientSession} from 'hooks';
import {ClientDynamicLayout} from 'layouts';
import {TRANSLATION_KEYS} from 'locale/translation-keys';
import {dynamicContentUtils} from 'utils/dynamic-content';
import './styles.scss';

const T_KEYS = TRANSLATION_KEYS.CLIENT_IN_SESSION_PAGE.IN_SESSION_WEB.REQUEST_APPOINTMENT_VIEW;

const {isMatchElement, renderDefaultNode} = dynamicContentUtils;
const getOptions = (props: any): HTMLReactParserOptions => {
    const {title, description, localParticipant} = props;
    return {
        replace: (domNode: any) => {
            if (!domNode.attribs) {
                return null;
            }

            const node = domNode as ParserElement;

            if (isMatchElement(Units.Title, node)) {
                return <NodeElement node={node}>{title}</NodeElement>;
            }
            if (isMatchElement(Units.Description, node)) {
                return <NodeElement node={node}>{description}</NodeElement>;
            }
            if (isMatchElement(Units.Icon, node)) {
                return <NodeElement node={node}><div className='icon' /></NodeElement>;
            }
            return renderDefaultNode(node, {role: localParticipant.role});
        }
    };
};

export const RequestAppointmentSubmitted: React.FC = () => {
    const {t} = useTranslation();
    const {image} = useClientSession();
    return (
        <ClientDynamicLayout image={image}>
            <ClientDynamicContent
                component={DynamicComponentNames.RequestAppointmentSubmitted}
                defaultTemplate={APPOINTMENT_SUBMITTED_DEFAULT_TEMPLATE}
                optionsProps={{
                    title: t(T_KEYS.RESULTS.SUBMITTED_TITLE),
                    description: t(T_KEYS.RESULTS.SUBMITTED_DESCRIPTION)
                }}
                optionsGetter={getOptions}
            />
        </ClientDynamicLayout>
    );
};
